import { createRef, Fragment, useState } from 'react';
import { useIsRTL } from '../../../locale';
import { CellContent, hasSelectionColumn, HeaderCellContent } from './internal';
import { SelectAllCellContent, SelectionCellContent } from './SelectionCellContent';
import '../Table.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const TableCell = props => {
  // NOTE: props.data is typed as `any`
  const isRTL = useIsRTL();
  const itemData = props.data;
  const [isDragging, setIsDragging] = useState(false);
  const isSelectionControl = hasSelectionColumn(itemData.selectionMode, itemData.columns.length, itemData.rowCount, itemData.hideSelectionControlColumn);
  const columnIndex = isSelectionControl ? props.columnIndex - 1 : props.columnIndex;
  const {
    onSort,
    renderCell,
    selectionMode,
    hideSelectAll,
    isRowDisabled,
    isRowReadOnly,
    getRowIdentifier: getRowKey
  } = itemData;
  const column = itemData.columns[props.columnIndex];
  if (!column) {
    return /*#__PURE__*/_jsx(Fragment, {});
  }
  const rowKey = props.rowIndex !== -1 ? getRowKey(props.rowIndex) : undefined;
  const readOnly = itemData.readOnly || (rowKey ? !!isRowReadOnly?.(rowKey) : false);
  const disabled = itemData.disabled || props.rowIndex > -1 && !!isRowDisabled?.(getRowKey(props.rowIndex));
  if (props.columnIndex === 0 && props.isHeader && (selectionMode === 'multiple' || selectionMode === 'toggle') && hideSelectAll !== true && itemData.rowCount > 0 && itemData.hideSelectionControlColumn !== true) {
    return /*#__PURE__*/_jsx(SelectAllCellContent, {
      rowIndex: props.rowIndex,
      itemData: itemData
    });
  } else if (props.isHeader) {
    return /*#__PURE__*/_jsx(HeaderCellContent, {
      itemData: itemData,
      style: props.style,
      columnIndex: columnIndex,
      column: column,
      sort: e => {
        // do not sort if we're dragging to resize the column
        if (!isDragging) onSort(e, column.key, true);
      },
      onDragStart: () => {
        setIsDragging(true);
      },
      onDragEnd: () => {
        setIsDragging(false);
        itemData.onColumnResize?.(column.key, itemData.preference?.resizedColumns?.has(column.key) ? itemData.preference?.resizedColumns?.get(column.key) || 0 : column.width || 0);
      },
      onDrag: deltaPX => {
        const index = hasSelectionColumn(itemData.selectionMode, itemData.columns.length, itemData.rowCount, itemData.hideSelectionControlColumn) ? columnIndex + 1 : columnIndex;
        isDragging && itemData.resizeColumn((isRTL ? -1 : 1) * deltaPX, index);
      }
    });
  } else if (column && column.cellContent) {
    const cellContent = column.cellContent;
    const ref = /*#__PURE__*/createRef();
    itemData.updateControlRefs(column.key, getRowKey(props.rowIndex), ref);
    const activateRef = /*#__PURE__*/createRef();
    itemData.updateActivateRefs(column.key, getRowKey(props.rowIndex), activateRef);
    let focusCellContent = itemData.preference?.scrollPosition?.editOnFocus;
    if (focusCellContent) {
      const cellToFocus = itemData.preference?.scrollPosition?.cell;
      const rowIndex = cellToFocus?.rowIndex;
      const colIndex = cellToFocus?.colIndex;
      const colKey = colIndex !== undefined ? itemData.columns[colIndex].key : '';
      focusCellContent = rowIndex === props.rowIndex && colKey === column.key;
    }
    return /*#__PURE__*/_jsx(CellContent, {
      rowIndex: props.rowIndex,
      columnKey: column.key,
      itemData: itemData,
      className: column.cellContainerClassName,
      style: column.cellContainerStyle,
      focus: focusCellContent,
      contentRef: ref,
      children: cellContent(columnIndex, props.rowIndex, column.key, ref, disabled, readOnly, activateRef)
    });
  } else {
    if (isSelectionControl && props.columnIndex === 0) {
      return /*#__PURE__*/_jsx(SelectionCellContent, {
        rowIndex: props.rowIndex,
        itemData: itemData
      });
    } else {
      const ref = /*#__PURE__*/createRef();
      itemData.updateControlRefs(column.key, getRowKey(props.rowIndex), ref);
      return /*#__PURE__*/_jsx(CellContent, {
        rowIndex: props.rowIndex,
        columnKey: column.key,
        itemData: itemData,
        className: column.cellContainerClassName,
        style: column.cellContainerStyle,
        contentRef: ref,
        children: renderCell({
          rowIndex: props.rowIndex,
          columnIndex,
          isScrolling: props.isScrolling,
          columnKey: column.key,
          disabled,
          readOnly,
          ref,
          itemData
        })
      });
    }
  }
};
//# sourceMappingURL=TableCell.js.map